import React, { useState } from "react";
import {PartyPopper, Heart, Users, Calendar, Trophy, Gift, Baby} from 'lucide-react';

const eventFormats = [
{
  id: 1,
  icon: PartyPopper,
  title: "Новогодний корпоратив",
  description: "Яркое и атмосферное ведение новогодних корпоративов. Создаю праздничное настроение и вовлекаю гостей в программу.",
  price: "от 30 000 ₽",
  features: ["Интерактивные игры", "Поздравления от коллег", "Праздничные конкурсы", "Координация программы"],
  images: [
  "https://static.lumi.new/c0/c0783bb2656913fe46d4f626d793e559.png",
  "https://cdn-static-lumi.artvibe.ai/2f/2f095b17f64e0847b1dab82c6b1a477a.jpg",
  "https://cdn-static-lumi.artvibe.ai/b9/b9171d14742e89eccdc700bec1313309.jpg"]

},
{
  id: 2,
  icon: Heart,
  title: "Свадебная вечеринка",
  description: "Полное ведение свадьбы от церемонии до банкета. Создаю волшебную атмосферу для вашего особенного дня.",
  price: "от 50 000 ₽",
  features: ["Ведение церемонии", "Банкетная программа", "Координация гостей", "Управление таймингом"],
  images: [
  "https://cdn-static-lumi.artvibe.ai/63/63fd2c4b9bfe0a2930be5fa91cc08c43.jpg",
  "https://cdn-static-lumi.artvibe.ai/00/001ea3b8999b56c760d8d1b5074ad8cb.jpg",
  "https://cdn-static-lumi.artvibe.ai/79/79b708c9f2668d1c26799e14d758821e.png"]

},
{
  id: 3,
  icon: Users,
  title: "Мафия-вечеринка",
  description: "Увлекательное ведение игры в мафию с профессиональной модерацией. Атмосферная игра для любой компании с напряжёнными моментами.",
  price: "от 20 000 ₽",
  features: ["Профессиональное судейство", "Создание атмосферы", "Вовлечение всех игроков", "Несколько раундов"],
  images: [
  "https://cdn-static-lumi.artvibe.ai/44/440d5c2d9ff44a8a5ca6be661411d557.jpg",
  "https://cdn-static-lumi.artvibe.ai/d3/d3d9503ece9085cf6c75b5e02a794aeb.jpg",
  "https://cdn-static-lumi.artvibe.ai/e9/e946ff496b7a5997b0ce97c2bd277f87.jpg"]

},
{
  id: 4,
  icon: Gift,
  title: "Гендер-пати",
  description: "Трогательное и радостное ведение праздника раскрытия пола будущего малыша. Создаю волнительную атмосферу.",
  price: "от 15 000 ₽",
  features: ["Торжественное раскрытие", "Игры для гостей", "Фотосессия с реквизитом", "Координация программы"],
  images: [
  "https://static.lumi.new/ee/ee1f0f2114a40fbae5f7ba8c4a85d496.jpg",
  "https://cdn-static-lumi.artvibe.ai/b8/b89a8b177db431b7f7fd345ac1f629a5.png",
  "https://cdn-static-lumi.artvibe.ai/97/971624e07f1238c0bbc61e2052495040.jpg"]

},
{
  id: 5,
  icon: Trophy,
  title: "Спортивные мероприятия",
  description: "Динамичное ведение турниров, соревнований и спортивных банкетов. Поддерживаю энергию и азарт.",
  price: "от 10 000 ₽",
  features: ["Объявление команд", "Представление участников", "Церемония награждения", "Праздничное настроение"],
  images: [
  "https://static.lumi.new/21/2174ac16cb01b71b5b2e928613324216.png",
  "https://cdn-static-lumi.artvibe.ai/b3/b377139f85d8df5911080fe6d10ebbe1.jpg"]

},
{
  id: 6,
  icon: Baby,
  title: "Детский праздник",
  description: "Весёлое и увлекательное ведение детских праздников. Создаю яркую атмосферу с играми и конкурсами для маленьких гостей.",
  price: "от 10 000 ₽",
  features: ["Игры и конкурсы", "Анимация", "Работа с детьми", "Праздничная программа"],
  images: [
  "https://cdn-static-lumi.artvibe.ai/f3/f356f4c15e16cd7d37b367831a0f828b.jpg",
  "https://cdn-static-lumi.artvibe.ai/76/76761e3d436f84b960bd867b81881660.png"]

},
{
  id: 7,
  icon: Calendar,
  title: "Индивидуальный формат",
  description: "Создание уникального формата ведения специально под ваше мероприятие. Реализую любые идеи.",
  price: "по договорённости",
  features: ["Разработка концепции", "Индивидуальный сценарий", "Гибкий подход", "Персональный тайминг"],
  images: []
}].filter((event) => event.id !== 7);


function EventFormats() {
  const [activeImage, setActiveImage] = useState<{[key: number]: number;}>({});

  const handleImageChange = (eventId: number, imageIndex: number) => {
    setActiveImage((prev) => ({ ...prev, [eventId]: imageIndex }));
  };

  return (
    <section id="events" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Форматы мероприятий и цены</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Комплексные услуги ведения, адаптированные под ваши потребности. Каждый пакет настраивается 
            индивидуально, чтобы воплотить вашу идею в жизнь.
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {eventFormats.map((event) => {
            const IconComponent = event.icon;
            const currentImageIndex = activeImage[event.id] || 0;

            return (
              <div
                key={event.id}
                className="bg-gray-900 border border-pink-300/20 rounded-2xl shadow-lg shadow-pink-300/10 hover:shadow-2xl hover:shadow-pink-300/20 transition-all duration-300 overflow-hidden group hover:-translate-y-2">

                {/* Image Gallery */}
                {event.images.length > 0 &&
                <div className="relative h-64 overflow-hidden">
                    <img
                    src={event.images[currentImageIndex]}
                    alt={`${event.title} ${currentImageIndex + 1}`}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" />

                    
                    {/* Image Navigation Dots */}
                    {event.images.length > 1 &&
                  <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2">
                        {event.images.map((_, index) =>
                    <button
                      key={index}
                      onClick={() => handleImageChange(event.id, index)}
                      className={`w-2 h-2 rounded-full transition-all ${
                      currentImageIndex === index ?
                      "bg-pink-300 w-6" :
                      "bg-white/50 hover:bg-white/80"}`
                      }
                      aria-label={`Показать фото ${index + 1}`} />

                    )}
                      </div>
                  }
                    
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-60" />
                  </div>
                }

                <div className="p-8">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-300 to-pink-400 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg shadow-pink-300/20">
                    <IconComponent className="w-8 h-8 text-black" />
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-white mb-3">{event.title}</h3>

                  {/* Description */}
                  <p className="text-gray-300 mb-4 leading-relaxed">{event.description}</p>

                  {/* Price */}
                  <div className="text-3xl font-bold text-pink-300 mb-6">{event.price}</div>

                  {/* Features */}
                  <ul className="space-y-2 mb-6">
                    {event.features.map((feature, index) =>
                    <li key={index} className="flex items-start text-gray-300">
                        <span className="text-pink-300 mr-2">✓</span>
                        <span className="text-sm">{feature}</span>
                      </li>
                    )}
                  </ul>

                  {/* CTA Button */}
                  <button 
                    onClick={() => {
                      const contactSection = document.getElementById("contact");
                      contactSection?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="w-full bg-pink-300 text-black py-3 rounded-lg font-semibold hover:bg-pink-400 transition shadow-lg shadow-pink-300/20">
                    Запросить расчёт
                  </button>
                </div>
              </div>);

          })}
        </div>

        {/* Custom Package CTA */}
        <div className="mt-16 bg-gradient-to-r from-pink-300 to-pink-400 rounded-3xl p-12 text-center text-black shadow-2xl shadow-pink-300/30">
          <h3 className="text-3xl font-bold mb-4">Нужен индивидуальный подход?</h3>
          <p className="text-lg mb-8 max-w-2xl mx-auto">Каждое мероприятие уникально. Давайте обсудим ваши потребности и создадим индивидуальный 
            формат проведения, идеально подходящий под ваше видение и бюджет.

          </p>
          <button 
            onClick={() => {
              const contactSection = document.getElementById("contact");
              contactSection?.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-black text-white border-2 border-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-900 transition shadow-lg">
            Записаться на консультацию
          </button>
        </div>
      </div>
    </section>);

}

export default EventFormats;